import { useParams } from "react-router-dom";
import Loading from "../../components/common/loading";
import useGetUserInfo from "../../hooks/useGetUserInfo";
import styles from "./styles.module.scss";
import { ReactComponent as Verified } from "../../assets/images/svg/Verified.svg";
import { ReactComponent as MapLocation } from "../../assets/images/svg/map-location.svg";

import classNames from "classnames";
import { PROFILE, COUNTRY } from "./constant";
import useGetContractStats from "../../hooks/useGetContractStats";
import { CONTRACTSITEMS, CONTRACT_STATS, MAP_STATE_TEXT } from "../../enums";
import ContractStats from "../../components/homeStats/contractStats";
import BankInfoModal from "./components/bankmodal/BankInfoModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Stats = () => {
  const { id } = useParams();
  const { data: userData, loading: userDataLoading } = useGetUserInfo(id);
  const { loading: contractStatsLoading, data: contractStats } =
    useGetContractStats(id);

  const [showBankInfoModal, setShowBankInfoModal] = useState(false);

  const { t } = useTranslation();

  if (userDataLoading || contractStatsLoading) return <Loading />;

  return (
    <div className={classNames(styles.page_layout, styles.page)}>
      <div className={styles.container}>
        <div className={classNames(styles.infoContainer, styles.card)}>
          <div className={styles.imgContainer}>
            <img
              src={
                userData?.profile.photoUrl || "../../../assets/images/user.png"
              }
              alt={userData?.profile.fullName}
              className={styles.avatar}
            />
            {userData?.nationalIdVerified ? <Verified /> : ""}
          </div>
          <div>
            <p className={styles.subtitle3}>{userData?.profile?.fullName}</p>
            <p className={classNames(styles.p4, styles.phone)}>
              {userData?.phoneNumber}
            </p>
          </div>
        </div>
        <div className={classNames(styles.addressContainer, styles.card)}>
          <p className={styles.title}>{PROFILE.ADDRESSES}</p>
          {userData?.profile?.addresses.length ? (
            <div>
              {userData?.profile?.addresses.map((address, index) => (
                <div key={address.id} className={styles.singleAddress}>
                  <p className={styles.p4}>
                    {PROFILE.ADDRESS} {index + 1}
                  </p>
                  <p className={styles.address}>
                    {COUNTRY[address.countryCode]} - {address.city} -
                    {address.district} - {address.street} - {address.buildingNo}{" "}
                    -{address.postalCode}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.noAddress}>
              <MapLocation />
              <p className={styles.address}>{PROFILE.NO_ADDRESS}</p>
            </div>
          )}
        </div>
        <div className={classNames(styles.bankInfoContainer, styles.card)}>
          <div
            className={styles.bankInfoButton}
            onClick={() => setShowBankInfoModal(true)}>
            {t("lbl_user_bank_info_btn")}
          </div>
        </div>
      </div>
      <div className={styles.contractStats}>
        {CONTRACTSITEMS?.map((item) => (
          <ContractStats
            key={item.key}
            title={CONTRACT_STATS[item.key]}
            item={item}
            values={contractStats}
            MAP_STATE_TEXT={MAP_STATE_TEXT}
          />
        ))}
      </div>
      <BankInfoModal
        showModal={showBankInfoModal}
        userId={id}
        onClose={() => {
          setShowBankInfoModal(false);
        }}
      />
    </div>
  );
};

export default Stats;
